import { z } from 'zod';
export const SearchSchema = z.object({
  id: z.string().optional(),
  // 拠点台帳は managed-place（自分が管掌する拠点）のみ（「すべて」は廃止）。
  // 管掌拠点を持たないメンバーは 200 + 空リストになる。
  scope: z.enum(['managed-place']).catch('managed-place')
});